import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router';
import '../questionsSearch/questionsSearch.scss';
import { NavLink, useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faCalculatorSimple } from '@fortawesome/pro-solid-svg-icons';
import { useParams } from 'react-router-dom';
import Modal from '../../components/Modal';
import { useActivitySearchContext } from './context';

const Index = () => {
  const { activityId } = useParams();
  const items =[
    {
      id: 1,
      icon: faMagnifyingGlass,
      name: 'Castle Vocabulary Search',
      path: `activities/${activityId ? activityId + '/' : ''}castle_activities/vocabularies`,
      comingSoon: false
    },
    {
      id: 2,
      icon: faCalculatorSimple,
      name: 'Personal Content Sets',
      path: `${activityId ? activityId + '/' : ''}personal_content_sets`,
      comingSoon: false
    }
  ];
  
  const navigate = useNavigate();
  const [showPendingChangesModal, setShowPendingChangesModal] = useState(false);
  const linkToRef = useRef();
  const context = useActivitySearchContext();

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('vocabularies')) {
      context.setSelectedTab(1);
    } else if (path.includes('personal_content_sets')) {
      context.setSelectedTab(2);
    }
  }, [window.location.href]);

  return (
    <>
      <div className='d-flex justify-content-end pb-3'>
        <button
          onClick={() => navigate('/assignments/flashcards')}
          className="btn btn-castleWhite btn-width">
          Back
        </button>
      </div>
      <div className="d-flex flex-column">
        <div className='d-flex flex-row flex-wrap align-items-stretch justify-content-between gap-3 mb-4'>
          {items.map((item, index) => (
            <>
              {item.comingSoon ? (
                <OverlayTrigger
                  key={`searchTypeToolTipKey${index}`}
                  placement="top"
                  overlay={
                    <Tooltip id={`toolTipId${index}`} className="custom-tooltip">
                      <p className="mb-0">Coming Soon!</p>
                    </Tooltip>
                  }>
                  <a key={`searchType_${index}`} className="questionSearchBtn" to={item.path} disabled >
                    <div className='iconBox'>
                      <FontAwesomeIcon icon={item.icon} />
                    </div>
                    {item.name}
                  </a>
                </OverlayTrigger>
              ) : (
                <>
                  <NavLink key={`searchType_${index}`} className={`questionSearchBtn ${context.selectedTab == item.id ? 'active' : ''}`} to={item.path}>
                    <div className='iconBox'>
                      <FontAwesomeIcon icon={item.icon} />
                    </div>
                    {item.name}
                  </NavLink>
                </>)}
            </>
          ))}

        </div>
        <Outlet />
      </div>

      <Modal
        isOpen={showPendingChangesModal}
        onClose={() => setShowPendingChangesModal(false)}
        contentWidth='40%'>
        <div className='d-flex flex-column'>
          <div>Changing sections will remove your currently selected vocabularies.  Would you like to continue?</div>

          <div className='d-flex flex-row gap-3 justify-content-end mt-4'>
            <Button variant='castleRed' className='w-25' onClick={() => setShowPendingChangesModal(false)}>No, stay here</Button>
            <Button variant='castleWhite' className='w-25' onClick={() => {
              setShowPendingChangesModal(false);
              navigate(linkToRef.current);
            }}>Yes</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Index;
